/**
 * Registre module-level du **site en cours d'édition** — les pages et leurs
 * blocs, tels que le sélecteur de cible d'un bouton doit les proposer.
 *
 * Il vit **hors** du store Puck (invariant §4.3 du README) : la sidebar le lit
 * par `useSyncExternalStore`. C'est le même arrangement que
 * `tableCatalogRegistry`, en plus simple — la source est déjà en mémoire, il
 * n'y a rien à charger.
 *
 * Le champ complète ce cliché par le contenu vivant de la page ouverte, que
 * seul le store Puck connaît : les blocs posés depuis le dernier point de
 * sauvegarde n'ont pas encore rejoint `webData`.
 */

const EMPTY = { webData: null, activeSlug: '' };

let snapshot = EMPTY;
const listeners = new Set();

/** Publié par l'éditeur à chaque changement de page ou de données. */
export function setSiteLinkTargetsSource({ webData, activeSlug } = {}) {
  if (snapshot.webData === webData && snapshot.activeSlug === activeSlug) return;
  snapshot = { webData: webData || null, activeSlug: activeSlug || '' };
  listeners.forEach((listener) => listener());
}

export function subscribeSiteLinkTargets(listener) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

export function getSiteLinkTargetsSnapshot() {
  return snapshot;
}

/** Remise à zéro complète — réservée aux tests. */
export function resetSiteLinkTargetsRegistry() {
  snapshot = EMPTY;
  listeners.clear();
}
